import VIcon from './VIcon'

export { VIcon }
export default VIcon



// WEBPACK FOOTER //
// ../../../src/components/VIcon/index.ts